import React, { Component } from 'react';
import { connect } from 'react-redux';

import { CSSTransitionGroup } from 'react-transition-group';

import { reduxForm, Field, change } from 'redux-form';
import { compose } from 'redux';

import { TextField } from 'redux-form-material-ui';
import { extractTenants } from 'helpers/tenantExtraction';
import * as validator from 'helpers/Validator';

import TenantResidentVerbiageHelper from 'components/shared/TenantResidentVerbiageHelper';
import PropertyUnitSelector from 'components/shared/PropertyUnitSelector';
import MultiSelectExtended from 'components/shared/MultiSelectExtended';
import Header from 'components/shared/Header';

import { deepDiver } from 'helpers/utilities';

import {
  getUnits,
  getActiveLeaseOfUnit,
  clearActiveLeaseOfUnit,
} from 'actions/landlordPropertiesActions';

const changeFieldValue = (field, value) => change('add_parcel', field, value);

let AddParcelForm = class AddParcelForm extends Component {
  constructor(props) {
    super(props);
    this.state = { showTenant: false, showParcels: false };
  }

  fetchActiveLeaseOfUnit = (unit, options) => {
    this.props.getActiveLeaseOfUnit(unit, options).then(result => {
      if (!result.value) {
        this.setState({ showParcels: true });
      }
      this.props.changeFieldValue('unit_active_lease', result.value);
      this.setState({ showTenant: true });
    });
  };

  onPropertyChange = propertyId => {
    this.setState({ showTenant: false, showParcels: false });
    this.props.allowParcelSubmit(false);
    this.props
      .getUnits(propertyId.value, { for_multiselect: true, only_active: true })
      .then(response => {
        if (!deepDiver(response, 'value.data.0.label')) {
          this.onUnitChange(deepDiver(response, 'value.data.0'));
        }
      });
  };

  onUnitChange = event => {
    this.clearSelections();
    this.props.allowParcelSubmit(false);

    if (!event.value) {
      this.setState({ showTenant: false });
      return;
    }
    this.clearSelections();
    this.fetchActiveLeaseOfUnit(event.value, { with_additional_occupants: true });
  };

  clearSelections = () => {
    this.props.clearActiveLeaseOfUnit();
    this.props.changeFieldValue('tenant', null);
  };

  onTenantChange = tenant_selected => {
    const selectedTenant = this._getRecipientType(tenant_selected);

    if (!selectedTenant) return;

    this.props.changeFieldValue('recipient_type', selectedTenant);
    this.setState({ showParcels: true });
    if (this.props.parcelUID) {
      this.props.allowParcelSubmit(true);
    }
  };

  _getRecipientType = tenantSelected => {
    const tenant = this.props.unitActiveLease.cotenants.find(
      cotenant => cotenant.full_name === tenantSelected.label
    );

    if (!tenant) return null;

    return tenant.recipient_type;
  };

  render() {
    let tenants = extractTenants(this.props.unitActiveLease);

    return (
      <form handleSubmit={this.onSubmit} autoComplete="off">
        <div className="row">
          {this.props.showPropertySelector && (
            <div>
              <Header name="PARCEL DETAILS" />

              <div className="row" style={{ marginBottom: '20px' }}>
                <PropertyUnitSelector
                  properties={this.props.properties}
                  units={this.props.units}
                  onPropertyChange={this.onPropertyChange}
                  propertyInnerDivStyle={{
                    width: '100%',
                    fontSize: '14px',
                    fontWeight: '100 !important',
                  }}
                  propertyMenuStyle={{ minWidth: '250px', fontSize: '14px' }}
                  propertyStyle={{ textAlign: 'left', fontSize: '14px' }}
                  unitMenuStyle={{ fontSize: '14px' }}
                  unitStyle={{ textAlign: 'left', fontSize: '14px' }}
                  onUnitChange={this.onUnitChange}
                />
                <CSSTransitionGroup
                  transitionName="show_dropdown_28px"
                  transitionEnterTimeout={500}
                  transitionLeaveTimeout={500}
                >
                  {this.state.showTenant &&
                    tenants.length > 0 && (
                      <div className="col-sm-12" style={{ margin: '30px 0 15px' }}>
                        <Field
                          name="tenant"
                          data={tenants || []}
                          onChange={(event, value) => {
                            this.onTenantChange(value);
                          }}
                          component={MultiSelectExtended}
                          hintText={<TenantResidentVerbiageHelper capitalize />}
                          innerDivStyle={{
                            width: '100%',
                            fontSize: '15px',
                            fontWeight: '100 !important',
                          }}
                          menuStyle={{ minWidth: '250px', fontSize: '14px' }}
                          style={{ fontSize: '14px' }}
                          fullWidth
                          validate={validator.required}
                          disabled={!this.props.unitActiveLease}
                        />
                      </div>
                    )}
                </CSSTransitionGroup>
              </div>
            </div>
          )}

          <RenderParcel showParcels={this.state.showParcels} parcelUID={this.props.parcelUID} />
        </div>
      </form>
    );
  }
};
const mapStateToProps = (state, ownProps) => {
  return {
    form: ownProps.formName,
    properties: state.landlordProperties.properties,
    units: state.landlordProperties.units,
    unitActiveLease: state.landlordProperties.unitActiveLease,
  };
};

export default compose(
  connect(mapStateToProps, {
    getActiveLeaseOfUnit,
    getUnits,
    clearActiveLeaseOfUnit,
    changeFieldValue,
  }),
  reduxForm()
)(AddParcelForm);

let ParcelsForm = class extends Component {
  render() {
    return (
      <div className="row">
        <Header name="PARCEL DETAILS" />

        <div className="row" style={{ paddingTop: '20px' }}>
          <h5 style={{ margin: '0', textAlign: 'center' }}> Parcel ID </h5>
          <div className="col-sm-12">
            <h2 style={{ textAlign: 'center', marginTop: '15px' }}>{this.props.parcelUID}</h2>
          </div>
          <div className="col-sm-12" style={{ textAlign: 'center', marginTop: '15px' }}>
            <h5 style={{ margin: '0', textAlign: 'center' }}> Parcel Description/Notes </h5>
            <Field
              name="notes"
              type="text"
              component={TextField}
              floatingLabelText="Parcel Notes"
              style={{ fontSize: '14px' }}
            />
          </div>
        </div>
      </div>
    );
  }
};

let RenderParcel = class extends Component {
  render() {
    return (
      <CSSTransitionGroup
        transitionName="show_parcels_form"
        transitionEnterTimeout={500}
        transitionLeaveTimeout={500}
      >
        {this.props.showParcels && <ParcelsForm parcelUID={this.props.parcelUID} />}
      </CSSTransitionGroup>
    );
  }
};
